import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './parkingfeeController.json';

const parkingfeeInit = (req, res, ctx) => {
  const responseData = apiResponses['parkingfeeController/parkingfeeInit'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('parkingfeeController/parkingfeeInit'), withScenario(withAuthCheck(parkingfeeInit))),
];
